import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import moment from "moment";

export default class extends Controller {
	connect() {
		console.log('initEventsForm');
		$('#event_start_at').parent().datetimepicker().on('dp.change', function (e: any) {
			if (e.date == null)
				return;
			const finish_at = $('#event_finish_at').parent().datetimepicker().data("DateTimePicker");
			if (finish_at.date() == null) {
				finish_at.date(e.date);
			} else if (e.oldDate != null) {
				finish_at.date(e.date.add(moment.duration(finish_at.date() - e.oldDate)));
			}
		});
	}
}
